/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 *
 */

// Storage keys
export enum STORAGE_KEYS {
  AUTH_TOKEN = 'auth-token',
  AUTH_TOKEN_EXPIRATION = 'auth-expiration',
  AUTH_REDIRECT = 'auth-redirect',
  AUTH_CODE_VERIFIER = 'code_verifier',
  TEST_SOURCE_ID_STATS = 'test-source-id-stats',
  TEST_SOURCE_ID_MATCH_HISTORY = 'test-source-id-match-history',
  ANALYTICS_SESSION_STORE = 'session-store',
  GLOBAL_SESSION_STORE = 'global-store',
  USER_PROFILE_STORE = 'user-profile-store',
  DBD_STATS_ALERT = 'dbd-stats-alert',
  DBD_MATCH_HISTORY_ALERT = 'dbd-match-history-alert',
  LANGUAGE = 'language',
}

// Timeframes
export enum TIMEFRAMES {
  THIRTY_DAYS = '30-days',
  ALL_TIME = 'all-time',
}

// Pages
export const ROOT_PAGE = '/';

// Analytics
export const EVENT_TYPE_VERSIONS = {
  session_start: 1,
  session_end: 0,
  session_info: 0,
  button_click: 0,
};
